import { normalizeHeaders, requestHeaders } from '@/api';
import settings from '@/data/constants';
import { StatusCode } from '@/error-handling/types';
import { tsRestFetchApi } from '@ts-rest/core';
import { initTsrReactQuery } from '@ts-rest/react-query/v5';

interface Contract {
  [key: string]: any;
}

interface CreateQueryClientArgs<T extends Contract> {
  contract: T;
  baseUrl?: string;
  baseHeaders?: Record<string, string>;
}

export function handleErrorResponseQueryClient(response: Response) {
  if (response.status === StatusCode.Unauthorised) {
    const errorBody = response.body;
    const error = new Error('Unauthorised request');

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (error as any).status = response.status;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (error as any).body = errorBody;
    throw error;
  }
  return response;
}

export function createQueryClient<T extends Contract>({
  contract,
  baseUrl = settings.baseXApiUrl,
  baseHeaders = {},
}: CreateQueryClientArgs<T>) {
  return initTsrReactQuery(contract, {
    baseUrl,
    baseHeaders,
    api: async (args) => {
      args.headers = normalizeHeaders({ ...requestHeaders(), ...args.headers });
      const response = await tsRestFetchApi(args);
      return handleErrorResponseQueryClient(response as Response);
    },
  });
}
